import { forwardRef } from "react"
import { createPrefixOfResource } from "../../common"

const IframeComp = forwardRef(({src, ...props}, ref) => (
    <iframe ref={ref} src={`${createPrefixOfResource()}${src}`} {...props} />
))

export default IframeComp